// *******************************************************************************
// Close Modal When Escape Key Press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modalElem = document.querySelectorAll('.modal');
    if (modalElem.length > 0) {
      modalElem.forEach((el) => {
        el.classList.remove('is-open-modal');
        toggleBodyScrollLock(false);
        Cookies.set('alert-modal-seen', allowedCookies, { expires: 7 });
      });
    }
  }
});

attachEvent('.modal__close, .modal__bg, .modal__close-btn', 'click', (ev) => {
  const parentSectionEle = ev.target.closest('section');
  const parentModal = ev.target.closest('.modal');
  parentModal.classList.remove('is-open-modal');
  toggleBodyScrollLock(false);

  if (parentSectionEle) {
    parentSectionEle.classList.remove('is-open-modal');
  }
  Cookies.set('alert-modal-seen', allowedCookies, { expires: 7 });
  ev.preventDefault();
});

// **************************************************
// Open modal
// **************************************************

attachEvent('.alert-modal-trigger', 'click', (ev) => {
  ev.preventDefault();
  const modal = document.querySelector('.alert-modal');
  modal.classList.add('is-open-modal');
  toggleBodyScrollLock(true);
  Cookies.set('alert-modal-seen', allowedCookies, { expires: 7 });
});

const alertModal = document.querySelector('.alert-modal');
if (alertModal && !alertModal.classList.contains('alert-modal')) {
  if (Cookies.get('alert-modal-seen') !== '') {
    alertModal.classList.add('is-open-modal');
  }
}
